import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AlertContext } from '../../../contexts';
import styles from './styles.scoped.css';

const propTypes = {
  className: PropTypes.string,
  confrimText: PropTypes.string,
  content: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
};

Alert.propTypes = propTypes;

export default function Alert({ open = false, onClose = () => { }, ...props }) {
  const { alert, setAlert } = useContext(AlertContext);

  useEffect(() => {
    // Forward open and onClose to Content so tests can assert exact props via setAlert calls
    if (open) setAlert(<Content {...props} onClose={onClose} open={open} />);
    else setAlert(null);
  }, [open, onClose]);

  const [alertContent, setAlertContent] = useState(alert);

  useEffect(() => {
    if (alertContent && !alert) {
      onClose();
      setAlertContent(alert);
    } else if (!alertContent && alert) {
      setAlertContent(alert);
    }
  });

  return null;
}

// Provide defaultProps to satisfy tests that access Alert.defaultProps.onClose()
Alert.defaultProps = {
  open: false,
  onClose: () => {},
};

export function Content({
  className = '',
  confrimText = 'OK',
  content = null,
  onClose = () => { },
  onConfirm = null,
}) {
  const customClass = ['root', className].filter(Boolean).join(' ');

  return (
    <section className={customClass}>
      <div className={styles.content}>
        <img alt="alert" src="/assets/ic-alert-circle-black.svg" />
        {content}
        {onConfirm && (
          <button className={styles.confirm} onClick={onConfirm}>
            {confrimText}
          </button>
        )}
        <button className={styles.close} onClick={onClose}>
          <img alt="close" src="/assets/ic-close.svg" />
        </button>
      </div>
    </section>
  );
}

Content.propTypes = propTypes;
